const MENTION_LINK_PROTOCOL = 'https:'

const parseAbsoluteUrl = (value: string) => {
  try {
    return new URL(value)
  } catch {
    return undefined
  }
}

export const resolveMentionLink = (value: unknown) => {
  if (typeof value !== 'string') return undefined

  const label = value.trim()

  if (!label || /\s/.test(label)) return undefined

  const url = parseAbsoluteUrl(label)

  if (!url || url.protocol !== MENTION_LINK_PROTOCOL || !url.hostname)
    return undefined

  if (url.username || url.password) return undefined

  return {
    href: url.href,
    label,
  }
}
